<template>
    <Dialog v-model:open="opened">
        <DialogContent v-if="confirmDialogData" class="p-0 sm:max-w-[598px]">
            <div class="mt-10 flex justify-center">
                <ProBadge />
            </div>

            <div class="px-10">
                <p class="text-lg font-medium text-iron-700 tracking-[-0.02em]">
                    {{ $t("pro_dialog.title") }}
                </p>

                <p class="text-iron-500 mt-[2px] tracking-[-0.02em]">
                    {{ $t("pro_dialog.description") }}
                </p>

                <p class="mt-6 font-medium text-iron-700 tracking-[-0.01em]">
                    {{ $t("pro_dialog.get_more") }}
                </p>

                <div class="w-full">
                    <ScrollArea class="">
                        <ul
                            class="mt-1 grid grid-cols-2 items-end space-y-[16px]"
                        >
                            <li
                                v-for="(value, i) in features"
                                :key="i"
                                class="gap-2 text-sm flex items-center"
                                :class="[
                                    i === 0
                                        ? 'font-medium text-iron-700'
                                        : 'text-iron-600',
                                ]"
                            >
                                <div
                                    class="flex shrink-0 items-center justify-center"
                                >
                                    <svg
                                        v-if="i === 0"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect
                                            width="20"
                                            height="20"
                                            rx="6"
                                            fill="url(#paint0_linear_2777_235)"
                                        />
                                        <path
                                            d="M14 7L8.5 12.5L6 10"
                                            stroke="white"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <defs>
                                            <linearGradient
                                                id="paint0_linear_2777_235"
                                                x1="-0.499512"
                                                y1="-1.25015"
                                                x2="17.4255"
                                                y2="18.4678"
                                                gradientUnits="userSpaceOnUse"
                                            >
                                                <stop stop-color="#FF8D47" />
                                                <stop
                                                    offset="0.329612"
                                                    stop-color="#FF8947"
                                                />
                                                <stop
                                                    offset="0.534043"
                                                    stop-color="#FF4247"
                                                />
                                                <stop
                                                    offset="0.68692"
                                                    stop-color="#E92A5B"
                                                />
                                                <stop
                                                    offset="0.828171"
                                                    stop-color="#DD1C67"
                                                />
                                                <stop
                                                    offset="1"
                                                    stop-color="#CF0283"
                                                />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                    <Unchecked v-else />
                                </div>

                                <p class="tracking-[-0.01em]">
                                    {{ value }}
                                </p>
                            </li>
                        </ul>
                    </ScrollArea>

                    <RadioGroup
                        class="mt-16 gap-4 grid grid-cols-2 items-center"
                        v-model:model-value="selectedPlanCycle"
                        default-value="yearly"
                    >
                        <div
                            class="rounded-lg relative h-[68px] p-[2px]"
                            :class="[
                                selectedPlanCycle === 'yearly'
                                    ? 'zap-gradient shadow-lg'
                                    : 'ring-iron-200 ring-[1px]',
                            ]"
                        >
                            <div class="bg-white rounded-[calc(8px-2px)]">
                                <div
                                    class="rounded-xl flex items-center justify-between"
                                >
                                    <Label
                                        class="gap-4 px-4 py-3 flex w-full items-center"
                                        for="yearly"
                                    >
                                        <RadioGroupItem
                                            id="yearly"
                                            value="yearly"
                                        >
                                            <RadioGroupIndicator>
                                                <CheckIconGradient></CheckIconGradient>
                                            </RadioGroupIndicator>

                                            <svg
                                                v-if="
                                                    selectedPlanCycle ===
                                                    'monthly'
                                                "
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g
                                                    clip-path="url(#clip0_2636_1564)"
                                                >
                                                    <path
                                                        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                                        stroke="#D1D1D6"
                                                        stroke-width="2"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath
                                                        id="clip0_2636_1564"
                                                    >
                                                        <rect
                                                            width="24"
                                                            height="24"
                                                            rx="12"
                                                            fill="white"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </RadioGroupItem>

                                        <div
                                            class="gap-1.5 flex w-full items-center justify-between"
                                        >
                                            <div>
                                                <p class="font-medium">
                                                    {{
                                                        $t(
                                                            "billing.card.yearly_payment",
                                                        )
                                                    }}
                                                </p>

                                                <p
                                                    class="font-normal text-iron-500 tracking-[-0.01em]"
                                                >
                                                    {{
                                                        formatPriceCurrency(
                                                            plans[0].price,
                                                            plans[0].currency,
                                                        )
                                                    }}
                                                </p>
                                            </div>

                                            <div
                                                class="zap-gradient -top-4 right-4 rounded-md py-1 text-sm font-medium text-white absolute px-[9px]"
                                            >
                                                Ušetříte 1 200 Kč
                                            </div>
                                        </div>
                                    </Label>
                                </div>
                            </div>
                        </div>

                        <div
                            class="rounded-lg h-[68px] p-[2px]"
                            :class="[
                                selectedPlanCycle === 'monthly'
                                    ? 'zap-gradient shadow-lg'
                                    : 'ring-iron-200 ring-[1px]',
                            ]"
                        >
                            <div class="bg-white rounded-[calc(8px-2px)]">
                                <Label
                                    class="gap-4 px-4 py-3 flex w-full items-center"
                                >
                                    <RadioGroupItem
                                        id="monthly"
                                        value="monthly"
                                    >
                                        <RadioGroupIndicator>
                                            <CheckIconGradient></CheckIconGradient>
                                        </RadioGroupIndicator>

                                        <svg
                                            v-if="
                                                selectedPlanCycle === 'yearly'
                                            "
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g
                                                clip-path="url(#clip0_2636_1564)"
                                            >
                                                <path
                                                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                                    stroke="#D1D1D6"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_2636_1564">
                                                    <rect
                                                        width="24"
                                                        height="24"
                                                        rx="12"
                                                        fill="white"
                                                    />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </RadioGroupItem>

                                    <div>
                                        <p class="font-medium">
                                            {{
                                                $t(
                                                    "billing.card.monthly_payment",
                                                )
                                            }}
                                        </p>

                                        <p
                                            class="font-normal text-iron-500 tracking-[-0.01em]"
                                        >
                                            {{
                                                formatPriceCurrency(
                                                    plans[1].price,
                                                    plans[1].currency,
                                                )
                                            }}
                                        </p>
                                    </div>
                                </Label>
                            </div>
                        </div>
                    </RadioGroup>

                    <div class="mb-8 mt-8">
                        <Button
                            :size="'lg'"
                            class="text-base font-medium h-[48px] w-full"
                            @click="confirm"
                            >{{ $t("pro_dialog.title") }}
                        </Button>
                    </div>
                </div>
            </div>
        </DialogContent>
    </Dialog>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from "vue";
import useConfirm from "../composables/useProDialog";
import { useAnalytics } from "@/composables/useAnalytics";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-vue-next";

import Switch from "@/components/ui/switch/Switch.vue";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useI18n } from "vue-i18n";
import { ScrollArea } from "@/components/ui/scroll-area";
import { router } from "@inertiajs/vue3";
import { usePage } from "@inertiajs/vue3";
import { Plan } from "@/Pages/Zaptime/App/Subscriptions/types";
import { formatPriceCurrency } from "@/Pages/Zaptime/App/Subscriptions/utils/formatPriceCurrency";
import ProBadge from "./ProBadge.svg";
import Checked from "./Checked.svg";
import Unchecked from "./Unchecked.svg";
import CheckIconGradient from "./CheckIconGradient.svg";
import { RadioGroup } from "@/components/ui/radio-group";
import { RadioGroupIndicator, RadioGroupItem } from "radix-vue";
import { Label } from "@/components/ui/label";

const { opened, confirmDialogData } = useConfirm();
const { t, locale } = useI18n();
const page = usePage();
const analytics = useAnalytics();

const plans = page.props.plans as Plan[];

const selectedPlan = ref(plans[0]);

const yearlyPeriod = ref(true);

const selectedPlanCycle = ref("yearly");

watch(opened, (isOpen) => {
    if (isOpen) {
        analytics.trackEvent("upgrade_prompt_shown", {
            feature: confirmDialogData.value?.feature ?? null,
        });
    }
});

function confirm() {
    analytics.trackEvent("upgrade_plan_selected", {
        plan_cycle: selectedPlanCycle.value,
        feature: confirmDialogData.value?.feature ?? null,
    });
    opened.value = false;
    router.visit("/billing" + "?preselectedplan=" + selectedPlanCycle.value);
}

watch(yearlyPeriod, () => {
    selectedPlan.value = yearlyPeriod.value ? plans[0] : plans[1];
});

function getFreshMap() {
    const featuresMap = new Map();

    featuresMap.set(
        "unlimited_events",
        t("pro_dialog.features.unlimited_events"),
    );
    featuresMap.set(
        "calendar_managed_availability",
        t("pro_dialog.features.calendar_managed_availability"),
    );
    featuresMap.set(
        "calendar_event_name",
        t("pro_dialog.features.calendar_event_name"),
    );
    featuresMap.set(
        "remove_branding",
        t("pro_dialog.features.remove_branding"),
    );

    featuresMap.set("paid_events", t("pro_dialog.features.paid_events"));
    featuresMap.set(
        "custom_workflow",
        t("pro_dialog.features.custom_workflow"),
    );
    featuresMap.set("analytics", t("pro_dialog.features.analytics"));
    featuresMap.set("custom_domain", t("pro_dialog.features.custom_domain"));
    featuresMap.set("integrations", t("pro_dialog.features.integrations"));
    featuresMap.set("booking_limit", t("pro_dialog.features.booking_limit"));
    featuresMap.set(
        "customize_confirmation_email",
        t("pro_dialog.features.customize_confirmation_email"),
    );
    featuresMap.set("days_off", t("pro_dialog.features.days_off"));
    featuresMap.set("guests", t("pro_dialog.features.guests"));

    featuresMap.set("teams", t("pro_dialog.features.teams"));

    return featuresMap;
}

const features = computed(() => {
    const featuresMap = getFreshMap();

    if (confirmDialogData.value?.feature) {
        const selectedFeature = featuresMap.get(
            confirmDialogData.value?.feature,
        );

        if (selectedFeature) {
            featuresMap.delete(confirmDialogData.value?.feature);

            return [selectedFeature, ...featuresMap.values()];
        }
    }

    return featuresMap.values();
});
</script>

<style>
.zap-gradient {
    background-image: linear-gradient(
        137.17deg,
        #ff8d47 10.41%,
        #ff7447 22.14%,
        #ff4247 46.48%,
        #e92a5b 61%,
        #dd1c67 69.21%,
        #d31071 77.36%,
        #cf0283 89.83%
    );
}
</style>
